import { motion } from 'framer-motion';
import { CSSProperties, ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  onClick?: () => void;
  selected?: boolean;
  hoverable?: boolean;
  style?: CSSProperties;
}

export default function Card({ children, onClick, selected = false, hoverable = true, style }: CardProps) {
  const baseStyles: CSSProperties = {
    background: 'white',
    borderRadius: 'var(--radius-lg)',
    padding: 'var(--spacing-xl)',
    border: `2px solid ${selected ? 'var(--color-primary)' : 'var(--color-border)'}`,
    cursor: onClick ? 'pointer' : 'default',
    position: 'relative',
    overflow: 'visible',
    zIndex: 0,
    ...style
  };

  return (
    <motion.div
      style={baseStyles}
      onClick={onClick}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      whileHover={
        hoverable && onClick
          ? {
              scale: 1.02,
              boxShadow: 'var(--shadow-xl)',
              zIndex: 2
            }
          : {}
      }
      whileTap={onClick ? { scale: 0.98 } : {}}
    >
      {children}
    </motion.div>
  );
}
